import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';
import Blamable        from '@/models/traits/Blamable';

@model.cacheDuration()
@model.urnResource('field_type')
@doc.path('/field_types/{?id}')
export default class FieldTypeModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt': string;
		'reference': Map_FieldTypeReference;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Map_FieldTypeReference;

	public get color() {
		return 'default';
	}
}